module.exports = __webpack_public_path__ + "img/yqc2.e5abc12f.jpg";